import { Flex, SegmentGroup, Segment } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";

type Instalments = {
  count: number;
  amount: string;
};

export type PaymentSummaryProps = {
  total: string;
  toPayToday: string;
  instalments: Instalments[];
};

export const PaymentSummary = (props: PaymentSummaryProps) => {
  const { total, toPayToday, instalments } = props;
  const classes = classNames("mobius", "mobius-payment-summary");

  return (
    <SegmentGroup className={classes}>
      <Segment className="mobius-payment-summary__to-pay-today">
        <Flex justifyContent="space-between">
          <span>
            <strong>To pay today</strong>
          </span>
          <span>
            <strong>{toPayToday}</strong>
          </span>
        </Flex>
      </Segment>
      {instalments.map(({ count, amount }) => (
        <Segment key={amount} className="mobius-payment-summary__instalments">
          <Flex justifyContent="space-between">
            <span>{count} monthly payments of</span>
            <span>{amount}</span>
          </Flex>
        </Segment>
      ))}
      <Segment className="mobius-payment-summary__total">
        <Flex justifyContent="space-between">
          <span>Total (inc. tax + fees)</span>
          <span>
            <strong>{total}</strong>
          </span>
        </Flex>
      </Segment>
    </SegmentGroup>
  );
};
